'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('clinic', {
    url: '/clinic/{id}/',
    params: {
      onboarding: null,
      click: null,
    },
    templateUrl: '/views/clinic.html',
    controller: 'ClinicCtrl',
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      clinic: function($stateParams, ClinicService, CurrentUser) {
        return CurrentUser.hasPermission('Clinic', $stateParams.id).then(function() {
          return ClinicService.getClinic($stateParams.id);
        });
      },
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set(clinic.name + ' - Opencare');
      },
      hasAppointments: function(clinic, AppointmentService) {
        return AppointmentService.hasAppointments('clinic', clinic.id);
      },
      numOpenIbSlots: function(clinic, AvailabilityService, OpencareConstants) {
        if (!clinic.providers.length) {
          return null;
        }
        return AvailabilityService.countForProviders(clinic.providers.map(function(provider) {
          return provider.id;
        }), moment().format(OpencareConstants.apiDateFormat), 14);
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicCtrl', function(
  $scope,
  $state,
  $stateParams,
  $rootScope,
  $location,
  $q,
  $timeout,
  PrimeInvoiceService,
  clinic,
  hasAppointments,
  numOpenIbSlots,
  ClinicService,
  OCModalUtil,
  CurrentUser,
  OCAppointmentUtil,
  OCClinicUtil,
  OpencareConstants,
  SentimentService,
  UserService,
  localStorageService,
  SignableDocumentsConstants,
  ClinicConfig,
  OCEligiblePMS,
  OCTrackedModals,
  NotificationService,
) {
  $scope.notifications = [];
  const updateNotifications = () => {
    $timeout(() => $scope.notifications = NotificationService.getNotifications(), 0);
  };
  NotificationService.onNotificationShown(updateNotifications);
  NotificationService.onNotificationCleared(updateNotifications);

  $scope.clinic = clinic;
  $scope.hasAppointments = hasAppointments;
  $rootScope.clinic = clinic;
  $scope.showLessThan10SlotsWarning = {
    value: shouldShowLessThan10SlotsWarning(), // make this an object so ClinicTimeslotsCtrl can update to hide warning
  };
  $scope.navigationTabs = [{
    label: 'Appointments',
    state: 'appointments',
    iconClassName: 'fa-user',
    available: true,
  }, {
    label: 'Calendar',
    state: 'timeslots',
    iconClassName: 'fa-calendar',
    available: true,
  }, {
    label: 'Performance',
    state: 'performance',
    iconClassName: 'fa-signal',
    available: true,
  }, {
    label: 'Providers',
    state: 'schedule',
    iconClassName: 'fa-user-md',
    available: true,
  }, {
    label: 'Profile',
    state: 'profile',
    iconClassName: 'fa-building-o',
    available: true,
  }, {
    label: 'Settings',
    state: 'settings',
    iconClassName: 'fa-cog',
    available: true,
  }];

  $scope.isPremiumMembership = (clinic) =>
    clinic.membership?.plan === OpencareConstants.clinicMembership.plan.PREMIUM
    && clinic.membership?.status === OpencareConstants.clinicMembership.status.ACTIVE;

  $scope.showSuperPracticeQuickView = false;
  $scope.$on('performance-widget-visibility-changed', (_event, visible) => {
    $scope.showSuperPracticeQuickView = visible;
  });

  $scope.manualIBExperimentModalClosed = localStorageService.cookie
    .get(OpencareConstants.manualIBExperiment.MODAL_CLOSED);

  $scope.openClinicProfilePage = function() {
    var clinicProfilePage = ClinicConfig.SEARCH_APP_V2_URL + '/results/' + $scope.clinic.id;
    window.open(clinicProfilePage);
  };

  $scope.showOCProOptInModal = (
    $scope.clinic?.metadata?.opencareProFeature
    && !$scope.clinic?.metadata?.clinicRoiOptInResponse?.optedAt
  );

  $scope.setIsClinicPaused = function() {
    $scope.isClinicPaused = $scope.clinic.providers.filter(function(p) {
      return !p.onlineBooking;
    }).length === $scope.clinic.providers.length;
  };
  $scope.setIsClinicPaused();

  $scope.$on('reloadClinic', function() {
    ClinicService.getClinic($stateParams.id).then(function(clinic) {
      $scope.clinic = clinic;
      $scope.getVerifiableAppointmentsCount();
      $scope.setIsClinicPaused();
    })
      .finally(function() {
        $scope.$broadcast('reloadClinicDone');
      });
  });

  $scope.$on('closeClinicV4', function() {
    $scope.$broadcast('reloadAppointmentOrganizer');
  });

  $scope.loadPerformanceDash = function() {
    $location.path('/clinic/' + $stateParams.id + '/performance/');
  };

  $scope.isCurrentState = function(stateName) {
    return $state.is(stateName);
  };

  $scope.currentTabName = () => $state.current.name.split('.')[1];

  $scope.verifyAward = function() {
    return OCModalUtil.showModal(
      'clinicAwardVerify',
      {
        clinic: $scope.clinic,
      },
    ).then(() => $scope.$broadcast('reloadClinic'));
  };

  if ($scope.showOCProOptInModal) {
    OCModalUtil.showModal(
      'clinicOCProOptIn',
      {
        clinic: $scope.clinic,
      },
    );
  }

  $scope.getVerifiableAppointmentsCount = () =>
    PrimeInvoiceService.getBillableEntity('clinic', $scope.clinic.id, moment().year(), moment().month() + 1)
      .then((billableEntity) =>
        $scope.verifiableAppointmentsCount = billableEntity.appointments
          ?.filter((appointment) => OCAppointmentUtil.needsVerification(appointment))
          .length);

  $scope.openAwardGuide = function() {
    return OCModalUtil.showModal(
      'claimAwardGuide',
      {
        clinic: $scope.clinic,
      },
    ).then(() => $scope.verifyAward());
  };

  const getOcProOfferDaysLeft = () => {
    const offerEndDate = OpencareConstants.ocProPromotionPeriod.END;
    const currentDate = moment();
    return offerEndDate.diff(currentDate, 'days');
  };

  const shouldShowCallNotificationModal = () => {
    const clinicCallNotificationFeature = $scope.clinic.notificationSettings?.unviewedAppointmentsReminder;
    return !clinicCallNotificationFeature && localStorageService.get('OcCallNotificationModalShown') !== 'true';
  };

  const showOcCallNotificationModal = () => {
    localStorageService.set('OcCallNotificationModalShown', 'true');
    return OCModalUtil.showCustomModal({
      windowClass: 'clinic-call-notification-feature-modal',
      templateUrl: '/views/modals/_call-notification-feature-modal.html',
      controller: 'ModalClinicCallNotificationFeature',
      resolve: OCModalUtil.createResolve({
        clinic: $scope.clinic,
      }),
    });
  };

  const shouldShowOcProCountdownModal = () => {
    const {
      PROMO_DAYS_TO_SHOW,
      CLINICS_TO_SHOW,
    } = OpencareConstants.ocProPromotionPeriod;
    const clinicPMS = $scope.clinic.metadata?.practiceManagementSoftware?.name;

    const isOcProCountdownEligible = CLINICS_TO_SHOW.includes($scope.clinic.id)
      && !$scope.clinic?.metadata?.opencareProFeature
      && OCEligiblePMS.some((pms) => pms.name === clinicPMS);
    const daysLeft = getOcProOfferDaysLeft();

    return isOcProCountdownEligible
      && PROMO_DAYS_TO_SHOW.includes(daysLeft)
      && localStorageService.get(`OcProExtendedCountdownModalShown-${daysLeft}`) !== 'true';
  };

  const showOCProCountdownModal = () => {
    const daysLeft = getOcProOfferDaysLeft();
    return OCModalUtil.showCustomModal({
      windowClass: 'clinic-oc-pro-countdown-modal',
      templateUrl: '/views/modals/_oc-pro-countdown.html',
      controller: 'ModalOCProCountdownCtrl',
      resolve: OCModalUtil.createResolve({
        daysLeft,
      }),
    }).finally(() => localStorageService.set(`OcProExtendedCountdownModalShown-${daysLeft}`, 'true'));
  };

  const shouldShowDocumentsToSign = () => {
    const lastSignedDocumentsAt = $scope.clinic.metadata?.signedDocumentsAt;
    return !CurrentUser.isImpersonatedInProd()
      && (
        !lastSignedDocumentsAt
        || moment(lastSignedDocumentsAt).isSameOrBefore(SignableDocumentsConstants.lastUpdatedAt)
      );
  };

  const showDocumentsToSignModal = () => {
    return OCModalUtil.showCustomModal({
      templateUrl: '/views/modals/_clinic-sign-BAA.html',
      controller: 'ClinicSignBAACtrl',
      size: 'lg',
      backdrop: 'static',
      resolve: OCModalUtil.createResolve({
        clinic: $scope.clinic,
      }),
    });
  };

  $scope.isValidUser = !CurrentUser.isImpersonatedInProd();

  $scope.isNewClinic = () => {
    return UserService.getClinicInvoiceReportPeriodMap($scope.clinic.id).then((invoiceReportPeriodMap) => {
      return Object.values(invoiceReportPeriodMap.monthsByYear).flat().length < 2;
    });
  };

  $scope.openCSatSurveyModal = function(clinic) {
    return OCModalUtil.showCustomModal({
      windowClass: 'modal-csat',
      templateUrl: '/views/modals/_csat-survey.html',
      controller: 'ModalCSatSurveyCtrl',
      size: 'lg',
      backdrop: 'static',
      resolve: OCModalUtil.createResolve({
        clinic,
      }),
    });
  };

  $scope.isEndOfMonth = function(todaysDate) {
    return todaysDate.date() >= 20;
  };

  $scope.isDateInRange = function(date, range) {
    return moment(date).isSame(moment(), range);
  };

  $scope.openCsatModalCheck = function(clinic, CurrentUser) {
    var today = moment();

    if (!$scope.isEndOfMonth(today)) {
      return $q.reject();
    }

    if (!$scope.isValidUser) {
      return $q.reject();
    }

    SentimentService.getClinicSentimentData(clinic.id)
      .then(function(clinicSentimentData) {
        // only applicable if there is a latest sentiment recorded
        if (clinicSentimentData.createdAt) {
          // reject if sentiment feedback was taken within 24 hours
          if ($scope.isDateInRange(clinicSentimentData.createdAt, 'day')) {
            return $q.reject();
          }
          // reject if current month is the same as sentiment created at month
          if ($scope.isDateInRange(clinicSentimentData.createdAt, 'month') && clinicSentimentData.score !== null) {
            return $q.reject();
          }
        }
      })
      .then(function() {
        return $scope.isNewClinic()
          .then(function(isNewClinic) {
            if (isNewClinic) {
              // reject if its a new clinic
              return $q.reject();
            }
          });
      })
      .then(function() {
        $scope.openCSatSurveyModal($scope.clinic, CurrentUser);
      });
  };

  $scope.openCsatModalCheck($scope.clinic, CurrentUser);

  CurrentUser.waitForUserLoad(CurrentUser.getUser).then(function(user) {
    if (!user.editable?.clinics?.length) {
      return;
    }

    const modals = [{ // OC Pro countdown modal
      shouldShow: shouldShowOcProCountdownModal,
      showCustom: showOCProCountdownModal,
    }, { // Call notification modal
      shouldShow: shouldShowCallNotificationModal,
      showCustom: showOcCallNotificationModal,
    }, {
      shouldShow: shouldShowDocumentsToSign,
      showCustom: showDocumentsToSignModal,
    }, {
      name: 'practiceManagementSoftware',
      shouldShow: () =>
        OCClinicUtil.hasPrimeDentalProviders($scope.clinic)
        && !$scope.clinic.syncEnabled
        && !$scope.clinic.metadata?.practiceManagementSoftware
        && !CurrentUser.isImpersonatedInProd()
        && !$scope.clinic.metadata?.enableOnboardingWizard,
      args: $scope.clinic,
    }, {
      name: 'clinicInstantBookUpdate',
      shouldShow: () =>
        !CurrentUser.isImpersonatedInProd()
        && $scope.clinic.metadata?.showInstantBookUpdateModal === true,
      args: $scope.clinic,
    }, {
      name: 'clinicInstantBookOutreach',
      shouldShow: () =>
        !CurrentUser.isImpersonatedInProd()
        && $scope.clinic.metadata?.instantBookOutreachModal?.shouldShow === true,
      args: {
        clinic: $scope.clinic,
      },
    }];

    const modal = modals.find((modal) => modal.shouldShow());
    if (!modal) {
      OCTrackedModals.showTrackedModalIfApplicable(clinic);
      return;
    }

    // Handle modals with a custom definition
    if (modal.showCustom) {
      return modal
        .showCustom()
        .finally(() => modal.finally?.());
    }

    return OCModalUtil.showModal(
      modal.name,
      modal.args,
    ).finally(() => modal.finally?.());
  });

  $scope.previousMonth = moment().subtract(1, 'month')
    .startOf('month')
    .format('MMMM');
  $scope.currentMonth = moment().startOf('month')
    .format('MMMM');
  $scope.currentDate = moment().date();

  $scope.getVerifiableAppointmentsCount();

  $scope.goToBillingMembership = function() {
    $state.go('user-prime', {
      tab: 'membership',
    });
  };

  // Default active tab.
  if ($scope.isCurrentState('clinic')) {
    if (hasAppointments) {
      $state.go('clinic.appointments', null, {
        location: 'replace',
      });
    } else {
      $state.go('clinic.schedule', null, {
        location: 'replace',
      });
    }
  }

  $scope.isSpringFeverParticipant = _.get(clinic, 'metadata.pick3SlotsFeatureIncentive', false);

  $scope.contestBannerIsClosed = localStorageService.cookie.get(OpencareConstants.springFever.CONTEST_BANNER_CLOSED);
  $scope.contestEndedBannerIsClosed = localStorageService.cookie
    .get(OpencareConstants.springFever.CONTEST_BANNER_WIN_CLOSED);
  $rootScope.contestHasEnded = OpencareConstants.springFever.IS_COMPLETED($scope.clinic.metadata?.pick3SlotUsageCount);

  $scope.springFeverBannerInfo = {
    title: 'It’s Spring Fever and we want to reward our practices with a 50$ giftcard!',
    description: 'We want to show you our appreciation. That’s why we are giving out $50 to practices who use our new scheduling feature to schedule 10 patients by May 15th!',
    imageClass: 'ribbon',
    linkText: 'Learn More',
  };

  $scope.springFeverBannerWin = {
    title: 'Congratulations, you did it! You get a $50 giftcard!',
    description: 'You’ve sent available times to 10 patient using the new feature! We’ll be sending you $50 at the end of Spring Fever (after May 15th). Thanks for participating and as always',
    imageClass: 'confetti',
    linkText: 'reach out if you have any feedback!',
    url: 'mailto:prime@opencare.com',
  };

  $scope.closeContestBanner = function() {
    $scope.contestBannerIsClosed = true;
    localStorageService.cookie.set(OpencareConstants.springFever.CONTEST_BANNER_CLOSED, 'true');
  };

  $scope.closeContestEndedBanner = function() {
    $scope.contestEndedBannerIsClosed = true;
    localStorageService.cookie.set(OpencareConstants.springFever.CONTEST_BANNER_WIN_CLOSED, 'true');
  };

  function shouldShowLessThan10SlotsWarning() {
    var hasLocalMed = _.some($scope.clinic.providers, function(provider) {
      return _.get(provider, 'metadata.localMedSettings.isEnabled', false) === true;
    });
    var hasOpencareSync = _.some($scope.clinic.providers, function(provider) {
      return _.get(provider, 'syncEnabled', false) === true;
    });
    var ibEnabled = hasLocalMed || hasOpencareSync;

    if (numOpenIbSlots < 10 && ibEnabled) {
      const lessThan10IbSlotsWarning = $scope.clinic.metadata?.lessThan10IbSlotsWarning || {};
      if (!lessThan10IbSlotsWarning.warningLastDisplayedAt || shouldShowWarningAgain(lessThan10IbSlotsWarning)) {
        lessThan10IbSlotsWarning.warningLastDisplayedAt = moment().format();
        ClinicService.updateClinic(clinic, {
          metadata: {
            lessThan10IbSlotsWarning,
          },
        });
        return true;
      }
    }
    return false;
  }

  function shouldShowWarningAgain(lessThan10IbSlotsWarning) {
    return moment().diff(moment(lessThan10IbSlotsWarning.warningLastDisplayedAt), 'days') > 14 || !actionWasTakenInLast14Days(lessThan10IbSlotsWarning);
  }

  function actionWasTakenInLast14Days(lessThan10IbSlotsWarning) {
    var lastIsInaccurateResponse = lessThan10IbSlotsWarning.lastIsInaccurateResponse;
    var lastIsAccurateResponse = lessThan10IbSlotsWarning.lastIsAccurateResponse;

    var lastIsInaccurateResponseParsed = lastIsInaccurateResponse ? moment(lastIsInaccurateResponse) : undefined;
    var lastIsAccurateResponseParsed = lastIsAccurateResponse ? moment(lastIsAccurateResponse) : undefined;

    return (
      (!!lastIsInaccurateResponseParsed && moment().diff(lastIsInaccurateResponseParsed, 'days') < 14)
      || (!!lastIsAccurateResponseParsed && moment().diff(lastIsAccurateResponseParsed, 'days') < 14)
    );
  }

  function resetExpiryReminderCards() {
    $scope.expiryReminderCards = [];

    const cards = (CurrentUser.getClinics() || [])
      .map((clinic) => clinic.membership?.billingCard)
      .filter(Boolean)
      .filter((paymentMethod) => paymentMethod.stripeObject === OpencareConstants.paymentMethod.type.CARD)
      .reduce((uniqCards, card) => {
        if (uniqCards.every((uniqCard) => uniqCard.id !== card.id)) {
          uniqCards.push(card);
        }
        return uniqCards;
      }, []);

    $scope.expiryReminderCards = cards.filter((card) => {
      const expiry = moment().year(card.expYear)
        .month(card.expMonth - 1)
        .startOf('month');
      card.daysLeft = expiry.diff(moment(), 'days');
      return card.daysLeft <= 30 && card.daysLeft >= 0;
    });
  }

  resetExpiryReminderCards();
});
